import { useAuthStore } from '@/hooks/useAuthStore'

export function clinicalSessionScope(userId: string | undefined, clinicId: string | null): string {
  return JSON.stringify([userId ?? null, clinicId])
}

export function clinicalStorageKey(name: string): string {
  const { user, activeClinicId } = useAuthStore.getState()
  return `${name}:${clinicalSessionScope(user?.id, activeClinicId)}`
}

function clearClinicalNavigation(userId: string): void {
  // Logout removes this account's navigation across its clinics. Storage may
  // be disabled by the browser; that must never prevent session teardown.
  for (const storageName of ['sessionStorage', 'localStorage'] as const) {
    try {
      const storage = window[storageName]
      for (const key of Object.keys(storage)) {
        const prefix = ['activePatientId:', 'hms-recent-patient-ids:'].find((item) => key.startsWith(item))
        if (!prefix) continue
        try {
          const [storedUserId] = JSON.parse(key.slice(prefix.length))
          if (storedUserId === userId) storage.removeItem(key)
        } catch { /* Ignore unrelated or malformed storage keys. */ }
      }
      storage.removeItem('activePatientId')
      storage.removeItem('hms-recent-patient-ids')
    } catch { /* Storage unavailable. */ }
  }
}

// A -> B -> A is a new session too. Storage keys stay stable, but in-flight
// requests belong to one uninterrupted visit to a clinic/account.
let requestGeneration = 0
useAuthStore.subscribe((state, previous) => {
  if (previous.user?.id && !state.user) clearClinicalNavigation(previous.user.id)
  if (state.user?.id !== previous.user?.id || state.activeClinicId !== previous.activeClinicId
      || state.isAuthenticated !== previous.isAuthenticated) requestGeneration += 1
})

export function clinicalRequestScope(): string {
  return `${clinicalStorageKey('request')}:${requestGeneration}`
}
